import { useTranslation } from "react-i18next";
import type { FinalLeaderboardEntry } from "@binogi-livequiz/shared";

interface PodiumProps {
  entries: FinalLeaderboardEntry[];
}

function Block({
  entry,
  height,
  color,
  label,
}: {
  entry: FinalLeaderboardEntry | undefined;
  height: number;
  color: string;
  label: string;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center">
      <div className="text-center mb-2 min-h-[3rem]">
        {entry ? (
          <>
            <div className="font-bold truncate max-w-[8rem]">
              {entry.displayName}
            </div>
            <div className="text-sm opacity-80 tabular-nums">
              {t("common.points_count", { count: entry.score })}
            </div>
          </>
        ) : (
          <div className="opacity-30 text-sm">—</div>
        )}
      </div>
      <div
        className={`${color} w-28 md:w-32 rounded-t-2xl flex items-end justify-center pb-3 text-2xl font-bold animate-slideUp`}
        style={{ height }}
      >
        {label}
      </div>
    </div>
  );
}

export function Podium({ entries }: PodiumProps) {
  const first = entries.find((e) => e.rank === 1);
  const second = entries.find((e) => e.rank === 2);
  const third = entries.find((e) => e.rank === 3);
  return (
    <div className="flex items-end justify-center gap-2 md:gap-3">
      <Block entry={second} height={120} color="bg-brand-coral" label="2" />
      <Block entry={first} height={170} color="bg-brand-amber" label="1" />
      <Block entry={third} height={90} color="bg-brand-purple" label="3" />
    </div>
  );
}
